unit search.subs;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.ExtCtrls, Vcl.Controls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCGridCell, VCL.TMSFNCGridOptions, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCCustomGrid, VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid, WEBLib.DB,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Buttons;

type
  TfrmSearchSubs = class(TForm)
    wsbMain: TScrollBox;
    wpMain: TPanel;
    gSearch: TTMSFNCGrid;
    gdaSearch: TTMSFNCGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    qSearch: TXDataWebDataSet;
    dsSearch: TDataSource;
    WebLabel1: TLabel;
    WebPanel1: TPanel;
    btnBack: TSpeedButton;
    qSearchSubCode: TStringField;
    qSearchSubName: TStringField;
    qSearchSuspended: TBooleanField;
    qSearchSubType: TIntegerField;
    qSearchTypeName: TStringField;
    btnSelect: TSpeedButton;
    weSearch: TEdit;
    procedure btnBackClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure qSearchAfterOpen(DataSet: TDataSet);
    procedure weSearchChange(Sender: TObject);
    procedure gSearchClick(Sender: TObject);
  private
    { Private declarations }

  public
    { Public declarations }
    bSuspended : Boolean;
    iType : Integer;
    sCode,
    sName : String;
    procedure GetData;
  protected procedure LoadDFMValues; override; end;

var
  frmSearchSubs: TfrmSearchSubs;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common;

procedure TfrmSearchSubs.btnBackClick(Sender: TObject);
begin
  sCode := '';
  sName := '';
  Close;
end;

procedure TfrmSearchSubs.btnSelectClick(Sender: TObject);
begin
  sCode := qSearch.FieldByName('SubCode').AsString;
  sName := qSearch.FieldByName('SubName').AsString;
  Close;
end;

procedure TfrmSearchSubs.GetData;
  procedure OnResult(Response : TXDataClientResponse);
  begin
    qSearch.Close;
    qSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
    qSearch.Open;
  end;
begin
  wcSearch.RawInvoke('IstfmssearchService.GetSubs', [bSuspended, iType], @OnResult);
  weSearch.SetFocus;
end;

procedure TfrmSearchSubs.gSearchClick(Sender: TObject);
begin
  weSearch.Text := '';
  weSearch.SetFocus;
end;

procedure TfrmSearchSubs.qSearchAfterOpen(DataSet: TDataSet);
begin
  gdaSearch.Active := True;


end;

procedure TfrmSearchSubs.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case gSearch.Selection.StartCol of
        0 : qSearch.Locate('SubCode', weSearch.Text, [loPartialKey]);
        1 : qSearch.Locate('SubName', weSearch.Text, [loPartialKey]);
        4 : qSearch.Locate('TypeName', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

procedure TfrmSearchSubs.LoadDFMValues;
begin
  inherited LoadDFMValues;

  wsbMain := TScrollBox.Create(Self);
  wpMain := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  gSearch := TTMSFNCGrid.Create(Self);
  gdaSearch := TTMSFNCGridDatabaseAdapter.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  btnBack := TSpeedButton.Create(Self);
  btnSelect := TSpeedButton.Create(Self);
  weSearch := TEdit.Create(Self);
  wcSearch := TXDataWebClient.Create(Self);
  qSearch := TXDataWebDataSet.Create(Self);
  qSearchSubCode := TStringField.Create(Self);
  qSearchSubName := TStringField.Create(Self);
  qSearchSuspended := TBooleanField.Create(Self);
  qSearchSubType := TIntegerField.Create(Self);
  qSearchTypeName := TStringField.Create(Self);
  dsSearch := TDataSource.Create(Self);

  wsbMain.BeforeLoadDFMValues;
  wpMain.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  gSearch.BeforeLoadDFMValues;
  gdaSearch.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  btnSelect.BeforeLoadDFMValues;
  weSearch.BeforeLoadDFMValues;
  wcSearch.BeforeLoadDFMValues;
  qSearch.BeforeLoadDFMValues;
  qSearchSubCode.BeforeLoadDFMValues;
  qSearchSubName.BeforeLoadDFMValues;
  qSearchSuspended.BeforeLoadDFMValues;
  qSearchSubType.BeforeLoadDFMValues;
  qSearchTypeName.BeforeLoadDFMValues;
  dsSearch.BeforeLoadDFMValues;
  try
    Name := 'frmSearchSubs';
    Width := 463;
    Height := 322;
    CSSLibrary := cssBootstrap;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    wsbMain.SetParentComponent(Self);
    wsbMain.Name := 'wsbMain';
    wsbMain.Left := 0;
    wsbMain.Top := 0;
    wsbMain.Width := 463;
    wsbMain.Height := 322;
    wsbMain.Align := alClient;
    wsbMain.AutoScroll := True;
    wsbMain.BorderStyle := bsSingle;
    wpMain.SetParentComponent(wsbMain);
    wpMain.Name := 'wpMain';
    wpMain.Left := 0;
    wpMain.Top := 0;
    wpMain.Width := 463;
    wpMain.Height := 322;
    wpMain.Align := alClient;
    wpMain.Color := clSilver;
    WebLabel1.SetParentComponent(wpMain);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 463;
    WebLabel1.Height := 32;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Search Companies';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.WidthPercent := 100.000000000000000000;
    gSearch.SetParentComponent(wpMain);
    gSearch.Name := 'gSearch';
    gSearch.Left := 0;
    gSearch.Top := 32;
    gSearch.Width := 463;
    gSearch.Height := 208;
    gSearch.Align := alClient;
    gSearch.ParentDoubleBuffered := False;
    gSearch.DoubleBuffered := True;
    gSearch.Font.Charset := DEFAULT_CHARSET;
    gSearch.Font.Color := clWindowText;
    gSearch.Font.Height := -13;
    gSearch.Font.Name := 'Tahoma';
    gSearch.Font.Style := [];
    gSearch.ParentFont := False;
    gSearch.TabOrder := 0;
    SetEvent(gSearch, Self, 'OnClick', 'gSearchClick');
    gSearch.DefaultRowHeight := 28.000000000000000000;
    gSearch.FixedColumns := 0;
    gSearch.RowCount := 1;
    gSearch.Options.Bands.Enabled := True;
    gSearch.Options.Editing.CalcFormat := '%g';
    gSearch.Options.Editing.Enabled := False;
    gSearch.Options.Grouping.CalcFormat := '%g';
    gSearch.Options.Grouping.GroupCountFormat := '(%d)';
    gSearch.Options.IO.XMLEncoding := 'ISO-8859-1';
    gSearch.Options.Mouse.ClickMargin := 0;
    gSearch.Options.Mouse.ColumnSizeMargin := 6;
    gSearch.Options.Mouse.RowSizeMargin := 6;
    gSearch.Options.Sorting.MultiColumn := False;
    gSearch.Adapter := gdaSearch;
    gSearch.Columns.Clear;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 150.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 250.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    with gSearch.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 90.000000000000000000;
    end;
    gSearch.DefaultFont.Charset := DEFAULT_CHARSET;
    gSearch.DefaultFont.Color := clWindowText;
    gSearch.DefaultFont.Height := -11;
    gSearch.DefaultFont.Name := 'Segoe UI';
    gSearch.DefaultFont.Style := [];
    gSearch.TopRow := 1;
    gSearch.Appearance.FixedLayout.Fill.Color := 16380654;
    gSearch.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FixedLayout.Font.Color := 4539717;
    gSearch.Appearance.FixedLayout.Font.Height := -13;
    gSearch.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FixedLayout.Font.Style := [fsBold];
    gSearch.Appearance.NormalLayout.Fill.Color := 16578806;
    gSearch.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.NormalLayout.Font.Color := 8026746;
    gSearch.Appearance.NormalLayout.Font.Height := -11;
    gSearch.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.NormalLayout.Font.Style := [];
    gSearch.Appearance.GroupLayout.Fill.Color := 12817262;
    gSearch.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.GroupLayout.Font.Color := clBlack;
    gSearch.Appearance.GroupLayout.Font.Height := -11;
    gSearch.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.GroupLayout.Font.Style := [];
    gSearch.Appearance.SummaryLayout.Fill.Color := 14009785;
    gSearch.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.SummaryLayout.Font.Color := clBlack;
    gSearch.Appearance.SummaryLayout.Font.Height := -11;
    gSearch.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.SummaryLayout.Font.Style := [];
    gSearch.Appearance.SelectedLayout.Fill.Color := 16441019;
    gSearch.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.SelectedLayout.Font.Color := 4539717;
    gSearch.Appearance.SelectedLayout.Font.Height := -11;
    gSearch.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.SelectedLayout.Font.Style := [];
    gSearch.Appearance.FocusedLayout.Fill.Color := 16039284;
    gSearch.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FocusedLayout.Font.Color := 4539717;
    gSearch.Appearance.FocusedLayout.Font.Height := -11;
    gSearch.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FocusedLayout.Font.Style := [];
    gSearch.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gSearch.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gSearch.Appearance.FixedSelectedLayout.Font.Height := -11;
    gSearch.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.FixedSelectedLayout.Font.Style := [];
    gSearch.Appearance.BandLayout.Fill.Color := 16711679;
    gSearch.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gSearch.Appearance.BandLayout.Font.Color := 8026746;
    gSearch.Appearance.BandLayout.Font.Height := -11;
    gSearch.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gSearch.Appearance.BandLayout.Font.Style := [];
    gSearch.Appearance.ProgressLayout.Format := '%.0f%%';
    gSearch.LeftCol := 0;
    gSearch.ScrollMode := scmItemScrolling;
    gSearch.GlobalFont.Scale := 1.000000000000000000;
    gSearch.GlobalFont.Style := [];
    gSearch.DesignTimeSampleData := True;
    gdaSearch.SetParentComponent(gSearch);
    gdaSearch.Name := 'gdaSearch';
    gdaSearch.Left := 160;
    gdaSearch.Top := 24;
    gdaSearch.Width := 26;
    gdaSearch.Height := 26;
    gdaSearch.Visible := True;
    gdaSearch.Grid := gSearch;
    gdaSearch.DataSource := dsSearch;
    gdaSearch.Columns.Clear;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'SubCode';
      Header := 'Account No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'SubName';
      Header := 'Name';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'Suspended';
      Header := 'Suspended';
      CheckBoxField := True;
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'SubType';
      Header := 'Type No';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with gdaSearch.Columns.Add do
    begin
      FieldName := 'TypeName';
      Header := 'Account Type';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    gdaSearch.AutoCreateColumns := False;
    WebPanel1.SetParentComponent(wpMain);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 240;
    WebPanel1.Width := 463;
    WebPanel1.Height := 82;
    WebPanel1.Align := alBottom;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := clSilver;
    btnBack.SetParentComponent(WebPanel1);
    btnBack.Name := 'btnBack';
    btnBack.Left := 330;
    btnBack.Top := 38;
    btnBack.Width := 108;
    btnBack.Height := 35;
    btnBack.Caption := 'Close';
    btnBack.Color := clCrimson;
    btnBack.Font.Charset := DEFAULT_CHARSET;
    btnBack.Font.Color := clWhite;
    btnBack.Font.Height := -13;
    btnBack.Font.Name := 'Tahoma';
    btnBack.Font.Style := [fsBold];
    btnBack.HeightStyle := ssAuto;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.ParentFont := False;
    btnBack.TabOrder := 0;
    btnBack.WidthPercent := 100.000000000000000000;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnSelect.SetParentComponent(WebPanel1);
    btnSelect.Name := 'btnSelect';
    btnSelect.Left := 18;
    btnSelect.Top := 38;
    btnSelect.Width := 108;
    btnSelect.Height := 35;
    btnSelect.Caption := 'Select';
    btnSelect.Color := clGreenyellow;
    btnSelect.Font.Charset := DEFAULT_CHARSET;
    btnSelect.Font.Color := clBlack;
    btnSelect.Font.Height := -13;
    btnSelect.Font.Name := 'Tahoma';
    btnSelect.Font.Style := [fsBold];
    btnSelect.HeightStyle := ssAuto;
    btnSelect.HeightPercent := 100.000000000000000000;
    btnSelect.ParentFont := False;
    btnSelect.TabOrder := 1;
    btnSelect.WidthPercent := 100.000000000000000000;
    SetEvent(btnSelect, Self, 'OnClick', 'btnSelectClick');
    weSearch.SetParentComponent(WebPanel1);
    weSearch.Name := 'weSearch';
    weSearch.Left := 18;
    weSearch.Top := 6;
    weSearch.Width := 420;
    weSearch.Height := 22;
    weSearch.CharCase := wecUpperCase;
    weSearch.ChildOrder := 2;
    weSearch.Font.Charset := DEFAULT_CHARSET;
    weSearch.Font.Color := clWindowText;
    weSearch.Font.Height := -13;
    weSearch.Font.Name := 'Tahoma';
    weSearch.Font.Style := [];
    weSearch.HeightStyle := ssAuto;
    weSearch.HeightPercent := 100.000000000000000000;
    weSearch.ParentFont := False;
    weSearch.WidthPercent := 100.000000000000000000;
    SetEvent(weSearch, Self, 'OnChange', 'weSearchChange');
    wcSearch.SetParentComponent(Self);
    wcSearch.Name := 'wcSearch';
    wcSearch.Connection := dmData.dbConnect;
    wcSearch.Left := 152;
    wcSearch.Top := 104;
    qSearch.SetParentComponent(Self);
    qSearch.Name := 'qSearch';
    qSearch.AfterOpen := qSearchAfterOpen;
    qSearch.Connection := dmData.dbConnect;
    qSearch.Left := 376;
    qSearch.Top := 96;
    qSearchSubCode.SetParentComponent(qSearch);
    qSearchSubCode.Name := 'qSearchSubCode';
    qSearchSubCode.FieldName := 'SubCode';
    qSearchSubName.SetParentComponent(qSearch);
    qSearchSubName.Name := 'qSearchSubName';
    qSearchSubName.FieldName := 'SubName';
    qSearchSuspended.SetParentComponent(qSearch);
    qSearchSuspended.Name := 'qSearchSuspended';
    qSearchSuspended.FieldName := 'Suspended';
    qSearchSubType.SetParentComponent(qSearch);
    qSearchSubType.Name := 'qSearchSubType';
    qSearchSubType.FieldName := 'SubType';
    qSearchTypeName.SetParentComponent(qSearch);
    qSearchTypeName.Name := 'qSearchTypeName';
    qSearchTypeName.FieldName := 'TypeName';
    dsSearch.SetParentComponent(Self);
    dsSearch.Name := 'dsSearch';
    dsSearch.AutoEdit := False;
    dsSearch.DataSet := qSearch;
    dsSearch.Left := 424;
    dsSearch.Top := 104;
  finally
    wsbMain.AfterLoadDFMValues;
    wpMain.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    gSearch.AfterLoadDFMValues;
    gdaSearch.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    btnSelect.AfterLoadDFMValues;
    weSearch.AfterLoadDFMValues;
    wcSearch.AfterLoadDFMValues;
    qSearch.AfterLoadDFMValues;
    qSearchSubCode.AfterLoadDFMValues;
    qSearchSubName.AfterLoadDFMValues;
    qSearchSuspended.AfterLoadDFMValues;
    qSearchSubType.AfterLoadDFMValues;
    qSearchTypeName.AfterLoadDFMValues;
    dsSearch.AfterLoadDFMValues;
  end;
end;

end.
